export const TX_PAGE_KEYS = {
  title: 'tx.title',
  backToTransactionsList: 'tx.actions.backToTransactionsList',
  goBack: 'tx.actions.goBack',
  viewAll: 'tx.actions.viewAll',
  showAll: 'tx.actions.showAll',
  hide: 'tx.actions.hide',
  showMore: 'tx.actions.showMore',
  showLess: 'tx.actions.showLess',
} as const;

export const TX_ACTION_TEXT_KEYS = {
  added: 'tx.actionText.added',
  removed: 'tx.actionText.removed',
  collected: 'tx.actionText.collected',
  swapped: 'tx.actionText.swapped',
  liquidityTo: 'tx.actionText.liquidityTo',
  liquidityFrom: 'tx.actionText.liquidityFrom',
  from: 'tx.actionText.from',
  on: 'tx.actionText.on',
  'for': 'tx.actionText.for',
  and: 'tx.actionText.and',
  minted: 'tx.actionText.minted',
  to: 'tx.actionText.to',
  ofTokenId: 'tx.actionText.ofTokenId',
} as const;

export const TX_TAB_KEYS = {
  details: 'tx.tabs.details',
  confidentialComputeDetails: 'tx.tabs.confidentialComputeDetails',
  assetFlows: 'tx.tabs.assetFlows',
  regularDetails: 'tx.tabs.regularDetails',
  tokenTransfers: 'tx.tabs.tokenTransfers',
  userOps: 'tx.tabs.userOps',
  internalTxns: 'tx.tabs.internalTxns',
  blobs: 'tx.tabs.blobs',
  logs: 'tx.tabs.logs',
  state: 'tx.tabs.state',
  rawTrace: 'tx.tabs.rawTrace',
} as const;

export const TX_EMPTY_KEYS = {
  tokenTransfers: 'tx.empty.tokenTransfers',
  filteredTokenTransfers: 'tx.empty.filteredTokenTransfers',
  internalTxns: 'tx.empty.internalTxns',
  blobs: 'tx.empty.blobs',
  logs: 'tx.empty.logs',
  stateChanges: 'tx.empty.stateChanges',
  assetFlows: 'tx.empty.assetFlows',
  rawTrace: 'tx.empty.rawTrace',
} as const;

export const TX_NOTICE_KEYS = {
  pendingConfirmation: 'tx.notice.pendingConfirmation',
  connectionLostUpdate: 'tx.notice.connectionLostUpdate',
  fetchInfoErrorUpdate: 'tx.notice.fetchInfoErrorUpdate',
} as const;

export const TX_DESCRIPTION_KEYS = {
  stateChanges: 'tx.description.stateChanges',
} as const;

export const TX_FIELD_KEYS = {
  action: 'tx.fields.action',
  wallet: 'tx.fields.wallet',
  transactionHash: 'tx.fields.transactionHash',
  method: 'tx.fields.method',
  statusAndMethod: 'tx.fields.statusAndMethod',
  l2StatusAndMethod: 'tx.fields.l2StatusAndMethod',
  withdrawalStatus: 'tx.fields.withdrawalStatus',
  confirmationStatus: 'tx.fields.confirmationStatus',
  l1Status: 'tx.fields.l1Status',
  revertReason: 'tx.fields.revertReason',
  block: 'tx.fields.block',
  blockConfirmations: 'tx.fields.blockConfirmations',
  txBatch: 'tx.fields.txBatch',
  batch: 'tx.fields.batch',
  timestamp: 'tx.fields.timestamp',
  kettle: 'tx.fields.kettle',
  actions: 'tx.fields.actions',
  transactionAction: 'tx.fields.transactionAction',
  from: 'tx.fields.from',
  to: 'tx.fields.to',
  interactedWithContract: 'tx.fields.interactedWithContract',
  contract: 'tx.fields.contract',
  created: 'tx.fields.created',
  contractCreation: 'tx.fields.contractCreation',
  commitmentTx: 'tx.fields.commitmentTx',
  confirmationTx: 'tx.fields.confirmationTx',
  finalized: 'tx.fields.finalized',
  sequenceTxHash: 'tx.fields.sequenceTxHash',
  verifyTxHash: 'tx.fields.verifyTxHash',
  value: 'tx.fields.value',
  transactionFee: 'tx.fields.transactionFee',
  posterFee: 'tx.fields.posterFee',
  networkFee: 'tx.fields.networkFee',
  gasPrice: 'tx.fields.gasPrice',
  feePerGas: 'tx.fields.feePerGas',
  gasLimit: 'tx.fields.gasLimit',
  gasUsageAndLimit: 'tx.fields.gasUsageAndLimit',
  gasUsedForL1: 'tx.fields.gasUsedForL1',
  gasUsedForL2: 'tx.fields.gasUsedForL2',
  l1GasUsed: 'tx.fields.l1GasUsed',
  l1GasUsedByTxn: 'tx.fields.l1GasUsedByTxn',
  l1GasPrice: 'tx.fields.l1GasPrice',
  l1Fee: 'tx.fields.l1Fee',
  l1FeeScalar: 'tx.fields.l1FeeScalar',
  gasFees: 'tx.fields.gasFees',
  base: 'tx.fields.base',
  max: 'tx.fields.max',
  maxPriority: 'tx.fields.maxPriority',
  burntFees: 'tx.fields.burntFees',
  blobFee: 'tx.fields.blobFee',
  blobGasUsage: 'tx.fields.blobGasUsage',
  blobGasFees: 'tx.fields.blobGasFees',
  moreDetails: 'tx.fields.moreDetails',
  other: 'tx.fields.other',
  otherAttributes: 'tx.fields.otherAttributes',
  txnType: 'tx.fields.txnType',
  queueIndex: 'tx.fields.queueIndex',
  nonce: 'tx.fields.nonce',
  position: 'tx.fields.position',
  rawInput: 'tx.fields.rawInput',
  decodedInputData: 'tx.fields.decodedInputData',
  originatingL1TxnHash: 'tx.fields.originatingL1TxnHash',
  completionL1TxnHash: 'tx.fields.completionL1TxnHash',
  incomingMessage: 'tx.fields.incomingMessage',
  outgoingMessage: 'tx.fields.outgoingMessage',
  tokensTransferred: 'tx.fields.tokensTransferred',
  tokensMinted: 'tx.fields.tokensMinted',
  tokensBurnt: 'tx.fields.tokensBurnt',
  tokensCreated: 'tx.fields.tokensCreated',
  allowedPeekers: 'tx.fields.allowedPeekers',
  mintAddress: 'tx.fields.mintAddress',
  burnAddress: 'tx.fields.burnAddress',
  type: 'tx.fields.type',
  fromTo: 'tx.fields.fromTo',
  address: 'tx.fields.address',
  before: 'tx.fields.before',
  after: 'tx.fields.after',
  change: 'tx.fields.change',
  tokenId: 'tx.fields.tokenId',
  blobHash: 'tx.fields.blobHash',
  dataType: 'tx.fields.dataType',
  sizeBytes: 'tx.fields.sizeBytes',
} as const;

export const TX_TOOLTIP_KEYS = {
  transactionHash: 'tx.tooltip.transactionHash',
  statusAndMethod: 'tx.tooltip.statusAndMethod',
  withdrawalStatus: 'tx.tooltip.withdrawalStatus',
  l1ConfirmationPath: 'tx.tooltip.l1ConfirmationPath',
  revertReason: 'tx.tooltip.revertReason',
  batchLifecycleStatus: 'tx.tooltip.batchLifecycleStatus',
  blockNumber: 'tx.tooltip.blockNumber',
  batchIndex: 'tx.tooltip.batchIndex',
  batchNumber: 'tx.tooltip.batchNumber',
  batchContainingTx: 'tx.tooltip.batchContainingTx',
  timestamp: 'tx.tooltip.timestamp',
  kettle: 'tx.tooltip.kettle',
  senderAddress: 'tx.tooltip.senderAddress',
  recipientAddress: 'tx.tooltip.recipientAddress',
  contractExecutionCompleted: 'tx.tooltip.contractExecutionCompleted',
  contractExecutionFailed: 'tx.tooltip.contractExecutionFailed',
  commitmentTx: 'tx.tooltip.commitmentTx',
  confirmationTx: 'tx.tooltip.confirmationTx',
  value: 'tx.tooltip.value',
  totalTransactionFee: 'tx.tooltip.totalTransactionFee',
  transactionFeeWithoutBlob: 'tx.tooltip.transactionFeeWithoutBlob',
  posterFee: 'tx.tooltip.posterFee',
  networkFee: 'tx.tooltip.networkFee',
  gasPrice: 'tx.tooltip.gasPrice',
  feePerGas: 'tx.tooltip.feePerGas',
  gasLimit: 'tx.tooltip.gasLimit',
  gasUsageAndLimit: 'tx.tooltip.gasUsageAndLimit',
  l2GasSetAsideForL1: 'tx.tooltip.l2GasSetAsideForL1',
  l2GasSpentOnL2: 'tx.tooltip.l2GasSpentOnL2',
  totalGasUsedOnL1: 'tx.tooltip.totalGasUsedOnL1',
  l1GasUsedByTxn: 'tx.tooltip.l1GasUsedByTxn',
  l1GasPrice: 'tx.tooltip.l1GasPrice',
  l1DataFee: 'tx.tooltip.l1DataFee',
  l1FeeScalar: 'tx.tooltip.l1FeeScalar',
  gasFees: 'tx.tooltip.gasFees',
  burntFees: 'tx.tooltip.burntFees',
  blobFee: 'tx.tooltip.blobFee',
  blobGasUsage: 'tx.tooltip.blobGasUsage',
  blobGasFees: 'tx.tooltip.blobGasFees',
  other: 'tx.tooltip.other',
  rawInput: 'tx.tooltip.rawInput',
  decodedInputData: 'tx.tooltip.decodedInputData',
  originatingL1TxnHash: 'tx.tooltip.originatingL1TxnHash',
  completionL1TxnHash: 'tx.tooltip.completionL1TxnHash',
  tokensTransferred: 'tx.tooltip.tokensTransferred',
  tokensMinted: 'tx.tooltip.tokensMinted',
  tokensBurnt: 'tx.tooltip.tokensBurnt',
  tokensCreated: 'tx.tooltip.tokensCreated',
  allowedPeekers: 'tx.tooltip.allowedPeekers',
  transactionAction: 'tx.tooltip.transactionAction',
  blockProducer: 'tx.tooltip.blockProducer',
  mintBurnAddress: 'tx.tooltip.mintBurnAddress',
} as const;

export const TX_INTERNAL_TYPE_KEYS = {
  call: 'tx.internalTypes.call',
  delegateCall: 'tx.internalTypes.delegateCall',
  staticCall: 'tx.internalTypes.staticCall',
  create: 'tx.internalTypes.create',
  create2: 'tx.internalTypes.create2',
  selfDestruct: 'tx.internalTypes.selfDestruct',
  reward: 'tx.internalTypes.reward',
} as const;

export const TX_INTERNAL_TYPE_KEY_MAP = {
  call: TX_INTERNAL_TYPE_KEYS.call,
  delegatecall: TX_INTERNAL_TYPE_KEYS.delegateCall,
  staticcall: TX_INTERNAL_TYPE_KEYS.staticCall,
  create: TX_INTERNAL_TYPE_KEYS.create,
  create2: TX_INTERNAL_TYPE_KEYS.create2,
  selfdestruct: TX_INTERNAL_TYPE_KEYS.selfDestruct,
  reward: TX_INTERNAL_TYPE_KEYS.reward,
} as const;
